import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

const CheckoutCancel = () => {
  return (
    <div data-testid="checkout-cancel-page" className="min-h-screen pt-32 pb-24 flex items-center justify-center bg-white">
      <div className="container-custom max-w-2xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-8">
            <XCircle size={48} className="text-red-600" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight">
            <span className="text-[#e84628]">Payment</span> Cancelled
          </h1>
          <p className="mt-4 text-neutral-500 text-lg">
            Your payment was cancelled. Your cart items are still saved.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/checkout"
              data-testid="retry-checkout"
              className="btn-primary inline-flex items-center gap-2"
            >
              <ArrowLeft size={18} />
              Return to Checkout
            </Link>
            <Link
              to="/shop"
              className="btn-secondary"
            >
              Continue Shopping
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
